<app-object-list [showFooter]="true" [allowObjectCreate]="false" [project]="project" (selected)="onSelect($event)">
    <div class="popup__footer">
        <button type="button" class="vwui-btn" (click)="onCancel()">Annuleer</button>
    </div>
</app-object-list>
